import { render, staticRenderFns } from "./TributeVideo.vue?vue&type=template&id=2894d0b4&scoped=true"
import script from "./TributeVideo.vue?vue&type=script&lang=js"
export * from "./TributeVideo.vue?vue&type=script&lang=js"
import style0 from "./TributeVideo.vue?vue&type=style&index=0&id=2894d0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2894d0b4",
  null
  
)

export default component.exports